var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.tabs),function(tab){return _c('r-tab',{key:tab.label,attrs:{"id":tab.label,"name":tab.title}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }